import { render, staticRenderFns } from "./NotificationsDate.vue?vue&type=template&id=42b88920&scoped=true&lang=pug"
import script from "./NotificationsDate.vue?vue&type=script&lang=ts"
export * from "./NotificationsDate.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsDate.vue?vue&type=style&index=0&id=42b88920&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b88920",
  null
  
)

export default component.exports